import axios from '../utils/axiosConfig';

const API_URL = '/api/v1/characters';
const PUBLIC_PATH = '/models';

// Define preset models with correct paths
const PRESET_MODELS = {
  character: [
    {
      id: 'xbot',
      name: 'X Bot',
      url: `${PUBLIC_PATH}/characters/X_Bot.fbx`,
      type: 'character',
      format: 'fbx',
      scale: 1
    }
  ]
};

export const uploadModel = async (file, metadata = {}, onProgress) => {
  const formData = new FormData();
  formData.append('model', file);
  
  // Add metadata
  Object.entries(metadata).forEach(([key, value]) => {
    formData.append(key, value);
  });

  try {
    const response = await axios.post(`${API_URL}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const progress = (progressEvent.loaded / progressEvent.total) * 100;
          onProgress(progress);
        }
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading model:', error);
    throw error.response?.data?.message || 'Failed to upload model';
  }
};

export const fetchModels = async (type = 'character') => {
  try {
    // Get models from the database
    const response = await axios.get(API_URL, {
      params: { type }
    });
    
    // Combine preset models with database models
    return [...(PRESET_MODELS[type] || []), ...response.data];
  } catch (error) {
    console.error('Error fetching models:', error);
    // If API fails, return preset models
    return PRESET_MODELS[type] || [];
  }
};

export const deleteModel = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting model:', error);
    throw error.response?.data || new Error('Failed to delete model');
  }
};

export const updateModel = async (id, updates) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, updates);
    return response.data;
  } catch (error) {
    console.error('Error updating model:', error);
    throw error.response?.data || new Error('Failed to update model');
  }
};
